import {actualizarMeson, actualizarFuncionario} from "./apis_jefatura";

// Base URL de la API desde las variables de entorno.
const API_BASE = import.meta.env.VITE_API_URL
// Traer información de un funcionario

/**
 * GET: obtener información de un funcionario por su ID
 * Endpoint: /accounts/funcionarios/<int:id>/
 */
export async function obtenerFuncionario(id_funcionario) {
  try {
    const response = await fetch(`${API_BASE}/accounts/funcionarios/${id_funcionario}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Error al obtener el funcionario ${id_funcionario}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerFuncionario:", error);
    throw error;
  }
}

// INICIO

/**
 * GET: obtener lista de mesones
 * - Endpoint: /service/meson/
 */
export async function getMesones() {
  try {
    const response = await fetch(`${API_BASE}/service/meson/`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Error al obtener mesones: ${response.status}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("getMesones: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error("Error en getMesones:", error);
    throw error;
  }
}

export async function obtenerMeson(id_funcionario) {
  try {
    const response = await fetch(`${API_BASE}/service/meson/${id_funcionario}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Error al obtener el mesón del funcionario ${id_funcionario}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerMeson:", error);
    throw error;
  }
}

/**
 * PUT: Actualiza solo el estado de un mesón (funcionarios)
 */
export async function actualizarEstadoMeson(mesonId, nuevoEstado) {
  // Llama a la función genérica, pero solo con el campo "estado"
  return actualizarMeson(mesonId, { estado: nuevoEstado });
}

// ATENCIÓN

/**
 * GET: llamar al siguiente estudiante
 * - Endpoint: /service/llamar-siguiente/
 */
export async function llamarSiguiente() {
  try {
    const response = await fetch(`${API_BASE}/service/llamar-siguiente/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error("Error al llamar al siguiente");
    }

    const data = await response.json();
    console.log(" Respuesta de llamarSiguiente:", data);
    return data
  } catch (err) {
    console.error(" Error en llamarSiguiente:", err);
    throw err;
  }
}

/**
 * POST: llamar a un estudiante en particular
 * - Endpoint: /service/llamar_por_id/<int:ticket_id>/<int:funcionario_id>/
 */
export async function llamarEstudianteParticular(id_estudiante, id_funcionario) {
  try {
    const response = await fetch(`${API_BASE}/service/llamar_por_id/${id_estudiante}/${id_funcionario}/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error(`Error al llamar al estudiante de id ${id_estudiante}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(" Error en llamarSiguiente:", error);
    throw error;
  }
}

/**
 * POST: descartar una atención en particular
 * - Endpoint: /service/descartar_atencion/<int:atencion_id>/
 */
export async function descartarAtencion(id_atencion) {
  try {
    const response = await fetch(`${API_BASE}/service/descartar_atencion/${id_atencion}/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error(`Error al descartar atención de id ${id_atencion}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(" Error en descartarAtencion:", error);
    throw error;
  }
}

// PUT para finalizar atención
export async function finalizarAtencion(id) {
  try {
    const response = await fetch(
      `${API_BASE}/service/finalizar_atencion/${id}/`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}), // o datos si necesitas enviar algo
        credentials: 'include',
      }
    );

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error en finalizarAtencion:", error);
    throw error;
  }
}

// GET para obtener la ficha del solicitante según su id, trae tambien las atenciones asociadas
export async function getFichaSolicitante(idSolicitante) {
  try {
    // Construir la URL de la API con el id del solicitante
    const url = `${API_BASE}/service/obtener-ficha/${idSolicitante}/`;

    // Hacer la solicitud GET a la API
    const response = await fetch(url, {
      method: "GET", // Método GET para obtener los datos
      headers: {
        "Content-Type": "application/json", // Indicar que esperamos respuesta en JSON
      },
      credentials: 'include',
    });

    // Verificar si la respuesta es exitosa
    if (!response.ok) {
      throw new Error("Error al obtener la ficha del solicitante");
    }

    // Parsear la respuesta JSON
    const data = await response.json();

    // Retornar la respuesta de la API
    return data;

  } catch (error) {
    console.error("obtenerFichaSolicitante error:", error);
    throw error; // Lanzar el error para manejarlo donde llames a la función
  }
}

// PUT para editar los datos del solicitante a partir de su id
export async function editarSolicitante(idSolicitante, payload) {
  try {
    const url = `${API_BASE}/accounts/solicitantes/${idSolicitante}/`;

    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      credentials: 'include',
    });

    if (!response.ok) {
      const errorData = await response.text();
      console.error("Error response:", errorData);
      throw new Error("Error al enviar datos del solicitante");
    }

    const responseData = await response.json();

    if (responseData.message === "Solicitante actualizado") {
      return responseData.message;
    } else {
      throw new Error("Respuesta inesperada de la API");
    }
  } catch (error) {
    console.error("editarSolicitante error:", error);
    throw error;
  }
}

/**
GET: get constante para que el funcionario vea la cola de espera
Endpoint: /service/home_funcionario/<id_funcionario>/
*/
export async function getHomeFuncionario(idFuncionario) {
  try {
    const response = await fetch(`${API_BASE}/service/home_funcionario/${idFuncionario}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error en getHomeFuncionario:", error);
    throw error;
  }
}

// PUT para agregar un comentario a una atencion a partir de su id
// por ahora solo se usa para la atencion actual
export async function agregarComentario(idAtencion, payload) {
  try {
    // Definir la URL de la API
    const url = `${API_BASE}/service/atenciones/${idAtencion}/`;

    // Hacer la solicitud PUT a la API con fetch
    const response = await fetch(url, {
      method: "PUT", // Método PUT para actualizar
      headers: {
        "Content-Type": "application/json", // Cabecera indicando que enviamos JSON
      },
      body: JSON.stringify(payload), // Enviar el cuerpo con el payload
      credentials: 'include',
    });

    // Comprobar si la respuesta fue exitosa
    if (!response.ok) {
      const errorData = await response.text(); // Obtener el cuerpo del error si no es OK
      console.error("Error response:", errorData);
      throw new Error("Error al actualizar la atención");
    }

    // Obtener y procesar la respuesta de la API
    const responseData = await response.json();

    // Comprobar si el mensaje es el esperado
    if (responseData.message === "Atención actualizada") {
      return responseData.message; // Retorna el mensaje de éxito
    } else {
      throw new Error("Respuesta inesperada de la API");
    }
  } catch (error) {
    console.error("actualizarAtencion error:", error); // Log del error
    throw error; // Re-lanzamos el error
  }
}

/**
 * POST: buscar solicitantes por substring en el nombre
 * Endpoint: /service/buscador/
 */
export async function buscarSolicitantes(substring) {
  try {
    const response = await fetch(`${API_BASE}/service/buscador/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ substring }),
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => "<no body>");
      console.error("buscarSolicitantes: respuesta no OK", response.status, text);
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("buscarSolicitantes: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    return await response.json();
  } catch (error) {
    console.error("Error en buscarSolicitantes:", error);
    throw error;
  }
}

/**
 * GET: obtener historial por funcionario
 * - Endpoint: /service/historial/<id_funcionario>/
 * @param {number|string} id_funcionario - ID del funcionario a consultar
 */
export async function getHistorial(id_funcionario) {
  try {
    const response = await fetch(`${API_BASE}/service/historial/${id_funcionario}/`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Error al obtener historial (ID ${id_funcionario}): ${response.status}`);
    }

    const contentType = (response.headers.get("content-type") || "").toLowerCase();
    if (!contentType.includes("application/json")) {
      const text = await response.text().catch(() => "<no body>");
      console.error("getHistorial: se esperaba JSON pero el servidor devolvió:", text);
      throw new Error("Respuesta no JSON del servidor");
    }

    const data = await response.json();
    console.log(data);
    return data;
  } catch (error) {
    console.error(`Error en getHistorial(${id_funcionario}):`, error);
    throw error;
  }
}

/**
 * GET: descargar ficha (PDF) del solicitante y forzar descarga en el navegador
 * - Endpoint: /service/descargar-ficha/<id_estudiante>/
 * Retorna el nombre de archivo descargado.
 */
export async function descargarFicha(id_estudiante) {
  try {
    const url = `${API_BASE}/service/descargar-ficha/${id_estudiante}/`;

    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      throw new Error(`Error al descargar ficha: ${response.status} ${text}`);
    }

    const contentType = (response.headers.get('content-type') || '').toLowerCase();
    if (!contentType.includes('application/pdf')) {
      const text = await response.text().catch(() => '<no body>');
      console.error('descargarFicha: se esperaba PDF pero el servidor devolvió:', text);
      throw new Error('La respuesta no es un PDF');
    }

    // Extraer filename desde Content-Disposition cuando esté disponible
    const cd = response.headers.get('content-disposition') || '';
    let filename = null;
    if (cd) {
      const m = cd.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
      if (m) filename = decodeURIComponent((m[1] || m[2] || '').trim());
    }
    if (!filename) filename = `ficha_${id_estudiante}.pdf`;

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();

    // liberar URL creada
    window.URL.revokeObjectURL(blobUrl);

    return filename;
  } catch (error) {
    console.error('Error en descargarFicha:', error);
    throw error;
  }
}

/**
 * GET: Obtiene la lista de funcionarios para el tab de estadísticas
 * @returns {Promise<Array>} - Array de funcionarios
 */
export async function obtenerListaFuncionariosJefatura() {
  try {
    const url = `${API_BASE}/feedback/lista-funcionarios/`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    return data.funcionarios || [];
  } catch (error) {
    console.error("Error en obtenerListaFuncionariosJefatura:", error);
    throw error;
  }
}

/**
 * GET: Obtiene estadísticas de funcionarios para el dashboard de jefatura
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido (last_week, last_month, etc.)
 * @param {string} params.startDate - Fecha de inicio (formato YYYY-MM-DD) para período personalizado
 * @param {string} params.endDate - Fecha de fin (formato YYYY-MM-DD) para período personalizado
 * @param {number} params.funcionarioId - ID del funcionario para filtrar (opcional)
 * @returns {Promise<Object>} - Objeto con las estadísticas de funcionarios
 */
export async function obtenerEstadisticasFuncionarios(params = {}) {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    if (params.funcionarioId) {
      queryParams.append('funcionario_id', params.funcionarioId);
    }

    const url = `${API_BASE}/feedback/estadisticas/funcionarios/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerEstadisticasFuncionarios:", error);
    throw error;
  }
}

/**
 * GET: Obtiene tabla de desempeño por funcionario
 * @param {Object} params - Parámetros de filtro
 * @param {string} params.period - Período predefinido
 * @param {string} params.startDate - Fecha de inicio
 * @param {string} params.endDate - Fecha de fin
 * @param {string} params.funcionarioIds - IDs de funcionarios separados por coma
 * @returns {Promise<Object>} - Objeto con array de funcionarios y sus métricas
 */
export async function obtenerDesempenoPorFuncionario(params = {}) {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.period && params.period !== 'custom') {
      queryParams.append('period', params.period);
    }
    
    if (params.startDate && params.endDate) {
      queryParams.append('start_date', params.startDate);
      queryParams.append('end_date', params.endDate);
    }

    if (params.funcionarioIds) {
      queryParams.append('funcionarioIds', params.funcionarioIds);
    }

    const url = `${API_BASE}/feedback/desempeno-por-funcionario/?${queryParams.toString()}`;
    
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error en obtenerDesempenoPorFuncionario:", error);
    throw error;
  }
}

export async function crearAtencionManual(idSolicitante, payload) {
  const response = await fetch(
    `${API_BASE}/service/atenciones/manual/${idSolicitante}/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(payload),
    });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      data.message || "No fue posible crear la atención"
    );
  }

  return data;
}


export async function anularAtencion(idAtencion, motivoAnulacion) {
  const response = await fetch(
    `${API_BASE}/service/atenciones/${idAtencion}/anular/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({
        motivo_anulacion: motivoAnulacion,
      }),
    }
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      data.message || "No fue posible anular la atención"
    );
  }

  return data;
}
